import { render, staticRenderFns } from "./viewLogBookOthers.vue?vue&type=template&id=089d7c57&scoped=true"
import script from "./viewLogBookOthers.vue?vue&type=script&lang=js"
export * from "./viewLogBookOthers.vue?vue&type=script&lang=js"
import style0 from "./viewLogBookOthers.vue?vue&type=style&index=0&id=089d7c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d7c57",
  null
  
)

export default component.exports